<div class="xvi-select-renderer" [ngClass]="class">
  <select
    [ngClass]="class"
    [attr.disabled]="disabled ? 'true' : null"
    [(ngModel)]="value"
    (ngModelChange)="finishEditing($event)"
  >
    <option *ngIf="isPinned" selected hidden value="">{{ defaultPinnedCellOption.text | translate }}</option>
    <option
      *ngFor="let option of options | async; trackBy: trackByValue"
      [value]="option.value"
      [disabled]="option.disabled"
    >
      {{ option.text | translate }}
    </option>
  </select>
</div>
